module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-case_study"
  }, [_c('hero-works', {
    attrs: {
      "props": _vm.pageData.elements,
      "heroHome": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('porfolio', {
    attrs: {
      "props": _vm.pageData.elements
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "inside",
    attrs: {
      "id": "section"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.pageData.elements) ? _c('div', {
    staticClass: "case-section case_study-box"
  }, [(_vm.pageData.elements.case_study_description.value !== '<p><br></p>') ? _c('div', {
    staticClass: "case_study_content inner-content no-gutters"
  }, [(_vm.pageData.elements.case_study_description) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.pageData.elements.case_study_description.value)
    }
  }) : _vm._e()]) : _c('div', {
    staticClass: "case_study_content inner-content case_short_study no-gutters"
  }, [(_vm.pageData.elements.case_study_short_description) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.pageData.elements.case_study_short_description.value)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.pageData.elements.case_study_description.value !== '<p><br></p>') ? _c('div', {
    staticClass: "case_study_aside inner-content no-gutters"
  }, [(_vm.solutions.length) ? [_c('h4', [_vm._v("Solutions")]), _vm._v(" "), _c('ul', _vm._l((_vm.solutions), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '/solutions/' + item.url.value
      }
    }, [_vm._v(_vm._s(item.header_title.value.trim()))])])
  }), 0)] : _vm._e(), _vm._v(" "), (_vm.pageData.elements.website_url.value.length) ? [_c('h4', [_vm._v("Website")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.pageData.elements.website_url.value
    }
  }, [_vm._v(_vm._s(_vm.pageData.elements.website_url.value))])] : _vm._e(), _vm._v(" "), (_vm.pageData.elements.awards.value.length >= 12) ? [_c('h4', [_vm._v("Awards")]), _vm._v(" "), _c('div', {
    staticClass: "awards-case-study",
    domProps: {
      "innerHTML": _vm._s(_vm.pageData.elements.awards.value)
    }
  })] : _vm._e()], 2) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "content-works"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "content-works-title col-md-10 col-md-offset-1 text-center"
  }, [_c('h2', [_vm._v("Related Work")]), _vm._v(" "), _c('p', {
    staticClass: "related"
  }, [_vm._v(_vm._s(_vm.relatedText))])])])]), _vm._v(" "), _c('boxes-wrapper', {
    attrs: {
      "boxes": _vm.relatedWorks,
      "modularContent": _vm.modularContent,
      "boxlimit": 3,
      "showViewAll": true
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2eb44e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/CaseStudy.vue
// module id = 1545
// module chunks = 0